import {
  IsBoolean,
  IsNotEmpty,
  IsOptional,
  IsUUID,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateLessonTeachingDto {
  @ApiProperty({ type: 'string', description: 'ID de la leçon' })
  @IsNotEmpty()
  @IsUUID('4')
  lessonId!: string

  @ApiProperty({ type: 'string', description: 'ID du chapitre' })
  @IsNotEmpty()
  @IsUUID('4')
  chapterId!: string

  @ApiProperty({ type: 'string', description: "ID de l'enseignement" })
  @IsNotEmpty()
  @IsUUID('4')
  teachingId!: string

  @ApiProperty({ type: 'string', description: 'ID de la matière (dénormalisé pour contrainte FK)' })
  @IsNotEmpty()
  @IsUUID('4')
  subjectExternalId!: string

  @ApiProperty({ type: 'string', description: 'ID du niveau (dénormalisé pour contrainte FK)' })
  @IsNotEmpty()
  @IsUUID('4')
  levelExternalId!: string

  @ApiPropertyOptional({ type: Boolean, description: 'Visibilité de la leçon', default: true })
  @IsOptional()
  @IsBoolean()
  isVisible?: boolean

  @ApiPropertyOptional({ type: 'string', description: 'ID du statut' })
  @IsOptional()
  @IsUUID('4')
  statusId?: string
}
